import { gql } from "@apollo/client";

export const validateHopRequestQuery = gql`
    query ValidateHopRequest($marketplaceId: String!, $shopId: String!) {
        validateHopRequest(marketplaceId: $marketplaceId, shopId: $shopId){
          marketplaceName
          miraklSsoEnabled
        }
    }
`;

export const getHopVerificationQuestionsQuery = gql`
    query GetHopVerificationQuestions($marketplaceId: String!, $shopId: String!) {
        getHopVerificationQuestions(marketplaceId: $marketplaceId, shopId: $shopId) {
            key
            title
        }
    }
`;


export const validateHopVerificationQuestionsQuery = gql`
query ValidateHopVerificationQuestions(
  $responses: [ShopVerificationQuestionResponse!]!
  $shopId: String!
  $marketplaceId: String!
) {
  validateHopVerificationQuestions(
    responses: $responses
    shopId: $shopId
    marketplaceId: $marketplaceId
  ) {
    invalidResponseKeys
    redirectUrl
  }
}
`;

export const getHopMiraklSsoQueryParametersQuery = gql`
    query GetHopMiraklSsoQueryParameters($marketplaceId: String!, $shopId: String!) {
      getHopMiraklSsoQueryParameters(marketplaceId: $marketplaceId, shopId: $shopId){
          clientId
          tenant
          audience
          state
          url
        }
    }
`;
